import React from 'react';
import { motion } from 'framer-motion';
import { Hand } from 'lucide-react';
const situations = ['Se bloquea al intentar leer palabras completas.', 'Se frustra y pierde la confianza en sí mismo.', 'Vos no sabés exactamente cómo ayudarlo.'];
export function ProblemSection() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-253">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-254">
        <div className="text-center mb-8" data-id="element-255">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-navy" data-id="element-256">
            ¿Hasta cuándo aprender a leer va a seguir siendo una lucha en tu
            casa?
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-257">
            Reconoce las letras, pero al leer palabras completas se bloquea y
            pierde confianza. No es falta de capacidad: solo necesita seguir el
            proceso correcto.
          </p>
        </div>

        <div className="bg-slate-50 rounded-3xl p-8 border border-slate-200 mb-8" data-id="element-258">
          <div className="space-y-4" data-id="element-259">
            {situations.map((text, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start bg-white p-4 rounded-xl shadow-sm border border-slate-100" data-id="element-260">
                <Hand className="w-5 h-5 text-amber-500 mr-4 flex-shrink-0 mt-1" data-id="element-261" />
                <p className="text-slate-700 font-medium" data-id="element-262">{text}</p>
              </motion.div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-263">
          <p className="text-xl font-bold text-navy italic" data-id="element-264">
            ¿Y si las próximas semanas pudieran ser el comienzo de sus primeras
            lecturas reales?
          </p>
        </div>
      </div>
    </section>;
}